import React, { useState, useEffect } from 'react';
import ControlTowerMap from './child/ControlTowerMap';
import config from '../config';
import { auth } from '../helper/auth';

const MapsLayer = () => {
    const [venues, setVenues] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchVenues();
    }, []);

    const fetchVenues = async () => {
        setLoading(true);
        try {
            // First attempt authenticated admin venues list
            let response = await auth.fetch(`${config.API_BASE_URL}/api/venues`);
            
            // If unauthorized or error, fall back to public venues endpoint
            if (!response.ok) {
                response = await fetch(`${config.API_BASE_URL}/api/public/venues?limit=100`);
            }

            if (response.ok) {
                const data = await response.json();
                const list = Array.isArray(data) ? data : (data.data || []);
                setVenues(list);
            } else {
                console.error('Failed to fetch venues for map:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching venues for map:', error);
            // Fallback attempt
            try {
                const pubRes = await fetch(`${config.API_BASE_URL}/api/public/venues?limit=100`);
                if (pubRes.ok) {
                    const pubData = await pubRes.json();
                    setVenues(Array.isArray(pubData) ? pubData : (pubData.data || []));
                }
            } catch (fallbackErr) {
                console.error('Fallback fetch also failed:', fallbackErr);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="row gy-4">
            <div className="col-12">
                {loading && venues.length === 0 ? (
                    <div className="card p-5 text-center radius-12 bg-white border-0 shadow-sm">
                        <div className="spinner-border text-primary me-2" role="status" />
                        <span className="text-secondary-light">Loading venue map...</span>
                    </div>
                ) : (
                    <ControlTowerMap 
                        venues={venues} 
                        height="620px" 
                        title="Venue Explorer & Map"
                    />
                )}
            </div>
        </section>
    );
};

export default MapsLayer;
